import { classNames } from '@utils/classNames.ts';
import type { DetailedHTMLProps, HTMLAttributes } from 'react';

export function Body5({
  children,
  className,
  ...rest
}: DetailedHTMLProps<
  HTMLAttributes<HTMLParagraphElement>,
  HTMLParagraphElement
>) {
  return (
    <span
      className={classNames(
        'font-normal text-slate-500 text-xs block',
        className,
      )}
      {...rest}
    >
      {children}
    </span>
  );
}
